import { isPhoneInput, sanitizePhoneInput } from './phone';
// Input restrictions preserve leading zeros and international phone notation.
export function sanitizeContactInput(value, kind) {
  const text = String(value ?? '');
  if (kind === 'postal') return text.replace(/[^0-9]/g, '');
  if (kind === 'phone') return sanitizePhoneInput(text);
  return text;
}
export function contactInputKind({ inputKind, type, name, id, autoComplete, 'data-testid': testId }) {
  if (inputKind) return inputKind;
  if (type === 'search') return undefined;
  if (isPhoneInput({ type, name, id, autoComplete, 'data-testid': testId })) return 'phone';
  const key = [name, id, testId, autoComplete].filter(Boolean).join(' ');
  if (/postal|postcode|postleitzahl|zip.?code/i.test(key)) return 'postal';
  if (/phone|telefon/i.test(key) && !/search|query|filter/i.test(key)) return 'phone';
  return undefined;
}
